import { render } from "./RealisasiKinerjaKpi.vue?vue&type=template&id=259bb358"
import script from "./RealisasiKinerjaKpi.vue?vue&type=script&lang=js"
export * from "./RealisasiKinerjaKpi.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__